import React from 'react';
import { observer } from 'mobx-react-lite';
import { Div, InputGroup, Typography, Panel } from '@icecreamsocial/components';
import { RequiredAsterisk } from '../../../../presentational';

const SquareOffers = ({ value, handleChange }) => {
	return (
		<Panel>
			<Panel.Body>
				<Typography.H3 typoWeight="600">Square Gift Card</Typography.H3>
				<Typography.P>
					Since your business has a Square account, influencers can be easily
					rewarded with a{' '}
					<Typography.A
						href="https://squareup.com/us/en/gift-cards"
						visitedTextColor="link"
					>
						Square Gift Card
					</Typography.A>
				</Typography.P>
				<hr />
				<InputGroup marginBottom="sm">
					<InputGroup.Label>
						Gift Card Value <RequiredAsterisk />
					</InputGroup.Label>
					<Div display="flex" alignItems="center">
						<InputGroup.Fields marginRight="md">
							<InputGroup.Input
								id="giftCardAmount"
								name="giftCardAmount"
								paddingLeft="md"
								value={value}
								onChange={handleChange}
							/>
						</InputGroup.Fields>
						<Typography.Span textColor="ambientDark">USD</Typography.Span>
					</Div>
				</InputGroup>
			</Panel.Body>
		</Panel>
	);
};
SquareOffers.displayName = 'SquareOffers';

export default SquareOffers;
